export const InputValidationError = ({ error }) => {
	if(error) {
		return (
			<span className="inputwrap-validation-error">
				{error}
			</span>
		)
	}
	else {
		return null;
	}
}